import React from 'react';
import TranslatedComponent from '../../utils/TranslatedComponent';

export class FoxLogo extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var classNames = ['logo', 'foxLogo'];
    if (this.props.isPrimary) {classNames.push('primaryLogo');}
    return (
      <svg className={classNames.join(' ')} viewBox="0 0 400 225" aria-labelledby='fox-logo-title' role='img'>
        <title id='fox-logo-title'>FOX</title>
        <g fill="none">
          <g id="Group-25" transform="translate(38.000000, 41.283113)" fill="#FFFFFF">
            <path d="M281.587222,67.8667512 L319.673015,0.836778425 C305.2579,1.07111085 276.989438,0.716887417 276.989438,0.716887417 L260.343607,30.095634 L243.479612,0.836778425 L199.519782,0.836778425 L239.056359,67.8667512 L197,140.716887 L240.158082,140.716887 L259.563674,105.561574 L279.001991,140.716887 L323,140.716887 L281.587222,67.8667512 Z" id="Fill-5"></path>
            <path d="M215.08153,92.3908967 C221.308257,71.8231622 217.320967,48.1694468 205.506571,31.4208872 C192.020791,12.6368935 171.953251,3.61422939 149.782825,2.71688742 C125.870008,4.0081844 103.115144,17.1728477 91.7486356,39.4531922 C79.8359233,59.3041474 82.1081325,91.4880832 95.4846719,110.047741 C110.505286,130.090203 131.637924,141.580557 157.107423,139.468521 C183.008423,138.045905 207.827939,116.99667 215.08153,92.3908967 L215.08153,92.3908967 Z M162.618622,101.222055 C162.618622,106.091777 158.096052,110.047741 152.661321,110.047741 L150.569359,110.047741 C145.107318,110.047741 140.601134,106.091777 140.601134,101.222055 L140.601134,40.9359951 C140.601134,36.0279722 145.107318,32.1157801 150.569359,32.1157801 L152.661321,32.1157801 C158.096052,32.1157801 162.618622,36.0279722 162.618622,40.9359951 L162.618622,101.222055 Z" id="Fill-7"></path>
            <polygon id="Fill-9" points="39.0948325 38.0986007 87 38.0986007 84.0247965 0.716887417 0 0.716887417 0 140.716887 39.8523566 140.716887 39.8523566 94.1957244 77.4540981 94.5012821 77.4540981 57.1795891 39.0948325 57.1795891"></polygon>
          </g>
        </g>
      </svg>
    );
  }
}

TranslatedComponent(FoxLogo);
export default FoxLogo;



// WEBPACK FOOTER //
// ./client/src/components/logos/FoxLogo.jsx